var tableSortInit;

(function ($) {

	const selectors = {
		table: '[data-table-sort]',
		heading: '[data-table-sort-heading]',
	}

	tableSortInit = function () {
		$(selectors.table).each((i, el) => {
			new TableSort(el);
		})
	}

	class TableSort {

		constructor(table) {

			const self = this;

			self.$table = $(table);
			self.$headings = $(selectors.heading, self.$table);

			self.init();
			self.bind();
		}

		init() {
			const self = this;

			self.inverse = false;
			self.currentSortIdx = false;

			self.$headings.addClass('o-sortable-heading').wrapInner('<span class="o-sortable-heading__label"></span>').append('<span class="o-sortable-heading__icons"></span>').wrapInner('<span class="o-sortable-heading__wrap">');

			self.currentSortIdx = self.$headings.filter('.o-sortable-heading--sorted').length ? self.$headings.filter('.o-sortable-heading--sorted').index() : false;
			// self.$headings.eq(self.currentSortIdx).addClass('o-sortable-heading--sorted');

		}
		bind() {
			const self = this;
			self.$headings.click(function () { self.sort($(this)) });
		}

		sort($heading) {

			const self = this;

			var idx = $heading.index();
			self.inverse = (self.currentSortIdx === idx) ? !self.inverse : false;
			self.currentSortIdx = idx;
			var is_numeric = $heading.attr('data-numeric') !== undefined;


			self.$headings.removeClass('o-sortable-heading--sorted o-sortable-heading--sorted-inverse');
			$heading.addClass('o-sortable-heading--sorted');
			if (self.inverse) $heading.addClass('o-sortable-heading--sorted-inverse');

			self.$table.find('tbody td').filter(function () {
				return $(this).index() === self.currentSortIdx;
			}).sortElements(function (a, b) {

				var a_val = $(a).attr('data-sort-val') ? $(a).attr('data-sort-val') : $(a).text().trim();
				var b_val = $(b).attr('data-sort-val') ? $(b).attr('data-sort-val') : $(b).text().trim();

				if (a_val == b_val) return 0;

				if (is_numeric) {

					if (!a_val) a_val = self.inverse ? "-100" : (Number.MAX_SAFE_INTEGER).toString();
					if (!b_val) b_val = self.inverse ? "-100" : (Number.MAX_SAFE_INTEGER).toString();

					a_val = parseFloat(a_val.replaceAll(" ", "").replaceAll(",", "."));
					b_val = parseFloat(b_val.replaceAll(" ", "").replaceAll(",", "."));

					if (!a_val && a_val !== 0) a_val = self.inverse ? -99 : Number.MAX_SAFE_INTEGER - 1;
					if (!b_val && b_val !== 0) b_val = self.inverse ? -99 : Number.MAX_SAFE_INTEGER - 1;
				}

				return a_val > b_val ? (self.inverse ? -1 : 1) : (self.inverse ? 1 : -1);

			}, function () {
				return this.parentNode;
			});

		}


	}


})(jQuery);


export default tableSortInit;



/**
 * jQuery.fn.sortElements
 * --------------
 * @author James Padolsey (http://james.padolsey.com)
 * @version 0.11
 * @updated 18-MAR-2010
 * --------------
 * @param Function comparator:
 *   Exactly the same behaviour as [1,2,3].sort(comparator)
 *   
 * @param Function getSortable
 *   A function that should return the element that is
 *   to be sorted. The comparator will run on the
 *   current collection, but you may want the actual
 *   resulting sort to occur on a parent or another
 *   associated element.
 *   
 *   E.g. $('td').sortElements(comparator, function(){
 *      return this.parentNode; 
 *   })
 *   
 *   The <td>'s parent (<tr>) will be sorted instead
 *   of the <td> itself.
 */
jQuery.fn.sortElements = (function () {

	var sort = [].sort;

	return function (comparator, getSortable) {

		getSortable = getSortable || function () { return this; };

		var placements = this.map(function () {

			var sortElement = getSortable.call(this),
				parentNode = sortElement.parentNode,

				// Since the element itself will change position, we have
				// to have some way of storing it's original position in
				// the DOM. The easiest way is to have a 'flag' node:
				nextSibling = parentNode.insertBefore(
					document.createTextNode(''),
					sortElement.nextSibling
				);

			return function () {

				if (parentNode === this) {
					throw new Error(
						"You can't sort elements if any one is a descendant of another."
					);
				}

				// Insert before flag:
				parentNode.insertBefore(this, nextSibling);
				// Remove flag:
				parentNode.removeChild(nextSibling);

			};

		});

		return sort.call(this, comparator).each(function (i) {
			placements[i].call(getSortable.call(this));
		});

	};

})();